exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".Spinner{width:100%;height:100%;animation:move 2s infinite linear}@keyframes move{0%{transform:rotate(0deg)}100%{transform:rotate(360deg)}}", ""]);
